































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import subFile from '@/components/document/subFile.vue';
import { queryTerm, queryFiles, editOriginalCode } from '@/api/document';
import moment from 'moment';
import { hasPermission } from '@/utils/utils';
import { mapGetters } from 'vuex';

const queryTypeMap = {
  1: 'fundId',
  2: 'companyIds',
  3: 'roundIds',
  4: 'fileTypeIds',
  5: 'originalCode'
};

@Component({ 
  components: { subFile }, 
  name: 'subFile' ,
  computed: { ...mapGetters(['userInfo'])}
})
class Tree extends Vue {
  @Prop({ type: Object, default: null })
  root;

  @Prop({ type: Number, default: 1 })
  indent!: number;

  @Prop({})
  num;

  @Prop({})
  fileType;

  @Prop({})
  typeList;

  @Prop({
    type: Object,
    default: function() {
      return {};
    }
  })
  queryObjList;

  @Prop({})
  folderNameList;

  @Prop({})
  selectedIds;

  @Prop({
    type: Array,
    default: function() {
      return [];
    }
  })
  queriedList;

  userInfo: any;

  get isChooseDownload() {
    if (!this.$store.state.fileExtraction.isChooseDownload) {
      this.checked = false;
    }
    return this.$store.state.fileExtraction.isChooseDownload;
  }

  get downloadNum() {
    return this.$store.state.fileExtraction.downloadList.length;
  }

  get fileSize() {
    return this.$store.state.fileExtraction.fileSize;
  }

  offset: any = 1;
  hasMore: boolean = false;
  page: number = 1;
  pageSize: number = 99;
  showFiles: any[] = [];
  queryTypeMap: Object = queryTypeMap;
  total: number = 0;
  editModal: boolean = false;
  originalCodeRule: object = {};
  fileInfo: object = {};
  hasPermisson: boolean = false;
  checked: boolean = false;
  isEllipsis: boolean = false;
  isShow: boolean = true;
  queriedTypeList: any = [];
  hasClicked: boolean = false;

  created() {
    const { permissions:queue } = this.userInfo || {};
    this.hasPermisson = hasPermission(queue, '/document/fileExtraction/originalCodeEdit');
  }

  mounted() {
    this.offset = this.indent;
    if (this.offset === this.num + 1) {
      this.offset++;
    }
    this.queriedTypeList = this.queriedList.slice(0);
  }

  async pushData(str) {
    this.isShow = true;
    if (this.root.children && this.root.children.length > 0 && !str) {
      this.root.unfold = true;
      this.isShow = true;
    } else {
      if (!this.hasClicked) {
        this.hasClicked = true;
        if (!this.root.unfold) {
          this.page = 1;
        }
        this.queryObjList[this.typeList[this.offset - 1].id] = this.root.id;
        if (this.offset === this.num) {
          try {
            let queryType = this.typeList[this.offset - 1].id;
            let selectedIds = {};
            for (let key in this.selectedIds) {
              if (key === queryType.toString()) {
                selectedIds[key] = this.selectedIds[key].join(',');
              }
            }
            this.queriedTypeList.push({ queryType: this.typeList[this.offset - 1].id, id: this.root.id });
            let data = {
              fileType: this.fileType,
              page: this.page,
              pageSize: this.pageSize
            };
            this.queriedTypeList.forEach(e => {
              data[this.queryTypeMap[e.queryType]] = e.id;
            });
            let queryTypeList: any = [];
            for (let key in this.queryObjList) {
              queryTypeList.push(key);
            }
            let res = await queryFiles(data);
            this.hasClicked = false;
            if (res.code === 200) {
              this.root.unfold = true;
              let list = res.data.list;
              this.total = res.data.total;
              this.page++;
              if (this.root.children) {
                this.root.children = this.root.children.concat(list);
              } else {
                this.$set(this.root, 'children', []);
                this.root.children = list;
              }
              this.root.children.forEach(e => {
                e.unfold = false;
              });
            }
          } catch (err) {
            console.log(err);
          }
        } else {
          try {
            let queryType = this.typeList[this.offset].id;
            let selectedIds = {};
            this.queriedTypeList.push({ queryType: this.typeList[this.offset - 1].id, id: this.root.id });
            let queriedTypeIds = this.queriedTypeList.map(_ => {
              return _.queryType;
            });
            Object.keys(this.selectedIds).forEach(key => {
              if (queriedTypeIds.indexOf(+key) === -1) {
                selectedIds[key] = this.selectedIds[key].join(',');
              }
            });
            let data = {
              fileType: this.fileType,
              queryType: queryType,
              page: this.page,
              pageSize: this.pageSize
            };
            this.queriedTypeList.forEach(e => {
              data[this.queryTypeMap[e.queryType]] = e.id;
            });
            Object.keys(selectedIds).forEach(key => {
              data[this.queryTypeMap[key]] = selectedIds[key];
            });
            // data[this.queryTypeMap[queryType]] = selectedIds[queryType];
            let res = await queryTerm(data);
            this.hasClicked = false;
            if (res.code === 200) {
              this.root.unfold = true;
              let list = res.data.list;
              this.page++;
              this.total = res.data.total;
              if (this.root.children) {
                this.root.children = this.root.children.concat(list);
              } else {
                this.$set(this.root, 'children', []);
                this.root.children = list;
              }
              this.root.children.forEach(e => {
                e.unfold = false;
                if (queryType === 5) {
                  e.id = e.name;
                }
              });
            }
          } catch (err) {
            console.log(err);
          }
        }
      }
    }
  }

  retractFile(id) {
    this.root.unfold = false;
    this.isShow = false;
  }

  async handleOk() {
    try {
      let res = await editOriginalCode({ fileType: this.fileType, fileId: this.root.id, originalCode: this.fileInfo['originalCode'] });
      if (res.code === 200) {
        this.$message.success('保存成功');
        this.editModal = false;
        this.root.originalCode = this.fileInfo['originalCode'];
        this.fileInfo = {};
      }
    } catch (err) {
      console.log(err);
    }
  }

  editOriginalCode() {
    this.editModal = true;
    this.fileInfo = { ...this.root };
  }

  onChange(e, id) {
    this.checked = e.target.checked;
    if (e.target.checked && this.downloadNum >= 100) {
      this.$message.error('选择的文件个数超过限制');
      this.checked = false;
    } else if (e.target.checked && (this.fileSize + this.root.size) / 1024 / 1024 > 500) {
      this.$message.error('选择的文件大小超过限制');
      this.checked = false;
    } else {
      let folderNameList = this.folderNameList.split('/');
      folderNameList.pop();
      let obj = {
        folder: folderNameList.join('/'),
        fileId: id
      };
      if (e.target.checked) {
        this.$store.dispatch('fileExtraction/addDownloadList', obj);
        this.$store.dispatch('fileExtraction/addDownloadSize', this.root.size);
      } else {
        this.$store.dispatch('fileExtraction/reduceDownloadList', obj);
        this.$store.dispatch('fileExtraction/reduceDownloadSize', this.root.size);
      }
    }
  }

  viewFile() {
    window.open(window.location.origin + '/pdfview?id=' + this.root.id);
  }
}
export default Tree;
